import { render } from "./readClubInfo.vue?vue&type=template&id=9a70e2a8&scoped=true"
import script from "./readClubInfo.vue?vue&type=script&lang=js"
export * from "./readClubInfo.vue?vue&type=script&lang=js"

import "./readClubInfo.vue?vue&type=style&index=0&id=9a70e2a8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a70e2a8"]])

export default __exports__